/**
 * Application API base URL
 */
let baseURL = process.env.API_BASE_URL || '/api/private'

export { baseURL }



// WEBPACK FOOTER //
// ./src/api/baseURLs.js